import {
  PecaAiAggregation,
  PecaAiAggregationListRequest,
  PecaAiSearchProductRequest,
  PecaAiSearchProductResponse,
} from './pecaAi.types';
import pecaAiServices from '../enterprise/pecaAi/pecaAi.services';
import { getPecaAiAccessToken } from '../enterprise/pecaAi/pecaAi.hooks';
import { PECAI_API_URL } from '.';
import axios from 'axios';

const productsPath = `${PECAI_API_URL}/products/aggregations`;
const searchProductPath = `${PECAI_API_URL}/products/search`;
const buyersPath = `${PECAI_API_URL}/buyers`;

export default {
  async brandList({ buyer: Buyer, data }: PecaAiAggregationListRequest) {
    const response = await axios.post<PecaAiAggregation[]>(
      `${productsPath}/brands`,
      data,
      { headers: { Buyer } },
    );
    return response.data;
  },

  async groupList({ buyer: Buyer, data }: PecaAiAggregationListRequest) {
    const response = await axios.post<PecaAiAggregation[]>(
      `${productsPath}/brands`,
      data,
      { headers: { Buyer } },
    );
    return response.data;
  },

  async searchProduct(data: PecaAiSearchProductRequest) {
    const token = await pecaAiServices.getToken();

    const response = await axios.post<PecaAiSearchProductResponse>(
      searchProductPath,
      data,
      {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      },
    );
    return response.data;
  },

  async hasBuyer(cnpj: string) {
    const token = getPecaAiAccessToken();

    const response = await axios.get<void>(`${buyersPath}/cnpj/${cnpj}`, {
      headers: { Authorization: `Bearer ${token?.access_token}` },
    });
    return response.data;
  },
};
